module.exports = __webpack_public_path__ + "img/custom-sound-box.99d3a3e4.jpeg";